// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { TenableCard } from './TenableCard';

const tenableCard = EntityCardBlueprint.make({
  name: 'tenable',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { TenableCard } = await import('./TenableCard');
      return <TenableCard />;
    },
  },
});

export const tenableCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [tenableCard],
});
